import { graphql } from 'gatsby';
import Meta from 'gatsby-theme-core/src/layout/meta';

// Write 2 different fragments because thats the easy way
export const query = graphql`
  fragment PagesPageHead on STRAPI_PagesPages {
    headTitle: title
    headSlug: slug
    headMetaDescription: metaDescription
    headImage: image {
      url # needed for projection
      src: url
      height
      width
      imageFile {
        name
        childImageSharp {
          fixed {
            src
            height
            width
          }
        }
      }
    }
  }
`;

export default Meta;
